import React from 'react';

import {Container} from './styles';
import {GasStationLocations} from '../../../../../GasStationLocations';
import {StationDTO} from '../../../../../../../dtos/StationDTO';
import {Localidade} from '../../..';

type Props = {
  posto: StationDTO;
  stationsByProductId?: StationDTO[];
  localidade: Localidade;
};

export function CoreGasStations({
  posto,
  stationsByProductId,
  localidade,
}: Props) {
  return (
    <Container>
      <GasStationLocations
        posto={posto}
        stationsByProductId={stationsByProductId || []}
        localidade={localidade}
      />
    </Container>
  );
}
